import { render, staticRenderFns } from "./FormStoreShippingComponent.vue?vue&type=template&id=5a67b417&scoped=true&"
import script from "./FormStoreShippingComponent.vue?vue&type=script&lang=js&"
export * from "./FormStoreShippingComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormStoreShippingComponent.vue?vue&type=style&index=0&id=5a67b417&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67b417",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VFlex,VForm,VLayout,VSwitch,VTextField})
